// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import "@fontsource-variable/space-grotesk"
import "@/styles/tokens.css"
import "@/styles/base.css"
import App from "./App"
import { initServiceWorker } from "./sw-register"
import { initTheme } from "@/lib/theme"

initTheme() // vor dem ersten Render — sonst blitzt das Standard-Theme auf
initServiceWorker()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
